<script>

import { angularInvoke } from '/vodalys/vvuejs'

export default {
    translate25Context: "transcript",
    props: ["component", "handler"],
    data: function () {
        return {
            uploading: false,
            url: null,
            notificationKeys: {},
            vnotification_service_js: null,
        };
    },
    mounted: function () {
        this.vnotification_service_js = angularInvoke(
            (vnotification_service_js) => vnotification_service_js
        );
    },
    destroyed() {
        if (this.vnotification_service_js) {
            Object.keys(this.notificationKeys).forEach((key) => {
                this.vnotification_service_js.remove(key);
            });
        }
    },
    methods: {
        click: function ($event, url) {
            $(this.$el).find("input.inputfile").click();
            this.url = url;
        },
        onFileChange: async function ($event) {

            const files = $event.target.files;
            if (!files || files.length === 0) {
                return;
            }

            const file = files[0];

            // Vérifier que c'est un fichier .vtt
            if (!file.name.toLowerCase().endsWith('.vtt')) {
                this.$vnotification.error(this.$vt('Please select a .vtt file'));
                this.$refs.input.value = "";
                return;
            }

            this.uploading = true;

            try {
                const formData = new FormData();
                formData.append('file', file);

                const response = await fetch(this.url, {
                    method: 'POST',
                    body: formData
                });

                // Lire la réponse comme texte d'abord pour pouvoir parser en JSON ou texte
                const responseText = await response.text();
                let result = null;
                let errorMessage = null;

                // Essayer de parser en JSON
                try {
                    result = JSON.parse(responseText);
                } catch (e) {
                    // Si ce n'est pas du JSON, utiliser le texte brut
                    result = { error: responseText };
                }

                // Vérifier si la réponse contient une erreur
                if (!response.ok || result.error) {
                    errorMessage = result.error || result.message || responseText || 'Upload failed';
                    throw new Error(errorMessage);
                }

                // Réinitialiser l'input
                this.$refs.input.value = "";

                // Afficher un message de succès
                if (result.success) {
                    const notif = {
                        '#type': 'vnotification:js',
                        'label': this.$vtc(`Successfully imported ${result.count} subtitle entries`),
                        'delay': 6 * 1000,
                        'severity': 0
                    };
                    const key = this.vnotification_service_js.add(notif);
                    this.notificationKeys[key] = key;
                }

                // Émettre un événement de succès si nécessaire
                if (this.handler && this.handler.onSuccess) {
                    this.handler.onSuccess(result);
                }
            } catch (error) {
                console.error('Upload error:', error);
                // Réinitialiser l'input pour permettre de réessayer l'upload
                this.$refs.input.value = "";
                // Afficher l'erreur dans une notification
                const notif = {
                    '#type': 'vnotification:js',
                    'label': this.$vtc('Error uploading file: ') + error.message,
                    'delay': 6 * 1000,
                    'severity': 1
                };
                const key = this.vnotification_service_js.add(notif);
                this.notificationKeys[key] = key;
            } finally {
                this.uploading = false;
            }
        },
    },
};
</script>

<template>
    <div class="transcript-import-vtt">
        <input type="file" name="file" id="file" class="inputfile" ref="input" accept=".vtt"
            @change="onFileChange($event)" />

        <f-button type="tertiary" @click="click($event, component.url)"> <f-icon icon="fa6-upload"></f-icon>{{
            $vt('Replace') }}</f-button>



    </div>
</template>

<style lang="scss">
.transcript-import-vtt {
    .inputfile {
        width: 0;
        height: 0;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
}
</style>